// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"Dd-z","heading":"Ed-z","screenReadersOnly":"Fd-z"};